export const teamsHostConfig = {
  fontFamily: "'Segoe UI', -apple-system, BlinkMacSystemFont, Roboto, 'Helvetica Neue', sans-serif",
  spacing: {
    small: 4,
    default: 8,
    medium: 12,
    large: 16,
    extraLarge: 24,
    padding: 12,
  },
  separator: {
    lineThickness: 1,
    lineColor: "#E1DFDD",
  },
  supportsInteractivity: true,
  fontSizes: {
    small: 12,
    default: 14,
    medium: 16,
    large: 20,
    extraLarge: 24,
  },
  fontWeights: {
    lighter: 300,
    default: 400,
    bolder: 600,
  },
  containerStyles: {
    default: {
      backgroundColor: "#FFFFFF",
      foregroundColors: {
        default: {
          default: "#252424",
          subtle: "#616161",
        },
        accent: {
          default: "#6264A7",
          subtle: "#8B8CC7",
        },
        attention: {
          default: "#C4314B",
          subtle: "#F3D6DA",
        },
        good: {
          default: "#13A10E",
          subtle: "#DFF6DD",
        },
        warning: {
          default: "#FFB900",
          subtle: "#FFF4CE",
        },
      },
    },
    emphasis: {
      backgroundColor: "#F9F8F7",
      foregroundColors: {
        default: {
          default: "#252424",
          subtle: "#616161",
        },
        accent: {
          default: "#6264A7",
          subtle: "#8B8CC7",
        },
        attention: {
          default: "#C4314B",
          subtle: "#F3D6DA",
        },
        good: {
          default: "#13A10E",
          subtle: "#DFF6DD",
        },
        warning: {
          default: "#FFB900",
          subtle: "#FFF4CE",
        },
      },
    },
  },
  actions: {
    maxActions: 6,
    spacing: "default",
    buttonSpacing: 8,
    showCard: {
      actionMode: "inline",
      inlineTopMargin: 16,
    },
    actionsOrientation: "horizontal",
    actionAlignment: "stretch",
  },
  adaptiveCard: {
    allowCustomStyle: true,
  },
  imageSet: {
    imageSize: "medium",
    maxImageHeight: 100,
  },
  factSet: {
    title: {
      color: "default",
      size: "default",
      isSubtle: false,
      weight: "bolder",
      wrap: true,
      maxWidth: 150,
    },
    value: {
      color: "default",
      size: "default",
      isSubtle: false,
      weight: "default",
      wrap: true,
    },
    spacing: 12,
  },
};
